
/**
 * @function StringConverter: Converts any given value to string
 * @param value: value to convert to string
 */
export let StringConverter = (value: any) => {
    if (value === null || value === undefined || typeof value === 'string') {
        return value;
    }

    return value.toString();
};

/**
 * @function BooleanConverter: converts any given value to boolean
 * @param value: Value to convert to boolean
 */
export let BooleanConverter = (value: any) => {
    if (value === null || value === undefined || typeof value === 'boolean') {
        return value;
    }

    return value.toString() === 'true';
};

/**
 * @function NumberConverter: converts the given string number to number
 * @param value value to convert to number
 */
export let NumberConverter = (value: any) => {
    if (value === null || value === undefined || typeof value === 'number') {
        return value;
    }

    // Return NaN for arrays and objects
    if (typeof value === 'object') {
        return NaN;
    }

    return parseFloat(value.toString());
};

/**
 * @function InputConverter: Converts a value to the selected type
 * @param converter: type selector
 */
export function InputConverter(converter?: (value: any) => any) {
    return (target: Object, key: string) => {
        if (converter === undefined) {
            const metadata = (<any>Reflect).getMetadata('design:type', target, key);
            if (metadata === undefined || metadata === null) {
                return;
            }

            if (metadata.name === 'String') {
                converter = StringConverter;
            } else if (metadata.name === 'Boolean') {
                converter = BooleanConverter;
                 } else if (metadata.name === 'Number') {
                converter = NumberConverter;
                 } else {
                return;
                 }
        }

        const converterFn: (value: any) => any = converter ?? ((value: any) => value);

        Object.defineProperty(target, key, {
            get: function () {
                return this['__' + key];
            },
            set: function (newValue) {
                this['__' + key] = converterFn(newValue);
            },
            enumerable: true,
            configurable: true
        });
    };
}
